import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  taRightsGroup: [],
}

export const mutations = {
  SET_TA_RIGHTS_GROUP(state, taRightsGroup) {
    state.taRightsGroup = taRightsGroup
  },
  ADD_TA_RIGHT_GROUP(state, taRightGroup) {
    state.taRightsGroup.push(taRightGroup)
  },
  EDIT_TA_RIGHT_GROUP(state, taRightGroup) {
    const index = state.taRightsGroup.findIndex(
      (element) => element.authority_uuid === taRightGroup.authority_uuid
    )
    if (index !== -1) {
      state.taRightsGroup.splice(index, 1, taRightGroup)
    }
  },
  DELETE_TA_RIGHT_GROUP(state, authority_uuid) {
    const index = state.taRightsGroup.findIndex(
      (element) => element.authority_uuid === authority_uuid
    )
    if (index !== -1) state.taRightsGroup.splice(index, 1)
  },
}

export const actions = {
  fetchTaRightsGroup({ commit }, payload) {
    return ApiService.fetchTaRightsGroup(payload)
      .then((res) => {
        const taRightsGroup = res.data.data
        commit('SET_TA_RIGHTS_GROUP', taRightsGroup)
      })
      .catch((error) => {
        throw error
      })
  },
  addTaRightGroup({ commit }, payload) {
    return ApiService.addTaRightGroup(payload)
      .then((res) => {
        const taRightGroup = res.data
        commit('ADD_TA_RIGHT_GROUP', taRightGroup)
      })
      .catch((error) => {
        throw error
      })
  },
  editTaRightGroup({ commit }, payload) {
    return ApiService.editTaRightGroup(payload)
      .then((res) => {
        const taRightGroup = res.data
        commit('EDIT_TA_RIGHT_GROUP', taRightGroup)
      })
      .catch((error) => {
        throw error
      })
  },
  deleteTaRightGroup({ commit }, payload) {
    return ApiService.deleteTaRightGroup(payload)
      .then(() => {
        commit('DELETE_TA_RIGHT_GROUP', payload.authority_uuid)
      })
      .catch((error) => {
        throw error
      })
  },
}
